define('models/CheckoutModel',['underscore', 'jquery', 'ObjectModel','app',
    'hooks',
    'models/PaymentGroupCollection',
    'models/PaymentModeModel',
    'template!blocks/checkout/submit',
    'views/pages/AuthentificationPageView',
    'views/blocks/OptinRgpdView',
    'models/EdenredDataModel',
    'validatorNIF',
    'phoneUtils',
    'UrlFactory',
    'formatPrice',
], function (_, $, ObjectModel, app,
             hooks,
             PaymentGroupCollection,
             PaymentModeModel,
             submitTemplate,
             AuthentificationPageView,
             OptinRgpdView,
             EdenredDataModel,
             validatorNIF,
             phoneUtils,
             UrlFactory,
             formatPrice
)
{
    //
    // Checkout Model
    // représente la vue de la page Checkout
    //
    var checkout;

    var _CART_TRANSLATION_CONTEXT_ = 'Cart';
    var _CHECKOUT_TRANSLATION_CONTEXT_ = 'Checkout';
    var steps, default_step = 'cart';

    var PROVIDER_REQUIRE_SIMPLE_PAYMENT = 40;
    var PROVIDER_REQUIRE_OGONE_CVC = 21;
    var PROVIDER_REQUIRE_OGONE_VALID_BRAND = 22;
    var PROVIDER_REQUIRE_OGONE_DIRECT_FORM = 50;
    function getZeroPaymentMode(){
        return app.getPaymentModes().findWhere({provider:'ZeroProvider'});
    }

    function AddStep(id,label,require_auth,require_product,require_valid_delivery_options,rewrite_conf,rewrite_default,submitLabel){
        var rewrite = app.c(rewrite_conf,rewrite_default),
            url = UrlFactory.getUrl('checkoutOpc',{rewrite:rewrite});
        steps.push({
            id:id,
            rewrite:rewrite,
            url:url,
            label:app.t(label,_CHECKOUT_TRANSLATION_CONTEXT_),
            require_product:require_product,
            require_valid_delivery_options:require_valid_delivery_options,
            require_auth:require_auth,
            submitLabel:app.t(submitLabel,_CHECKOUT_TRANSLATION_CONTEXT_),
        })
    }

    function ResetSteps(){
        steps = _([]);
        AddStep('cart','Panier',false, false,false,'_CART_BASE_URL_','panier', 'Passer aux accompagnements');
        AddStep('cross_selling','Accompagnements',false,true, false,'_CHECKOUT_CROSS_SELLING_REWRITE_','cross-selling', 'Passer au paiement');
        AddStep('payment','Paiement',true, true,true,'_CHECKOUT_PAYMENT_REWRITE_','paiement', 'Valider la commande');
    }

    function GetSteps(){
        if(!steps){ResetSteps();}
        return steps;
    }

    function GetStep(id){
        var steps = GetSteps();
        return steps.findWhere({id:id});
    }

    function getCart(){
        return app.getCart();
    }

    function getCustomer(){
        return app.getCustomer();
    }

    var CheckoutModel = ObjectModel.extend({

        defaults: {
            current_step:default_step,
            auth: false,
            address: false,
            payment: false,
            useasphonecustomer: true,
            shopMessage:'',
            addressData:null,
            alt_payment_mode:null,
        },

        initialize: function () {

            if(checkout) checkout.off();
            checkout = this;
            var cart = getCart(),
                customer = getCustomer();
            // defaults values
            checkout.set({
               phone:getCustomer().getPhoneOrder(),
               tax_identification_number:customer.getTaxIdentficationNumber()||'',
            });
            ResetSteps();
            window.checkout = checkout;
            checkout.listenTo(customer,"login logout", checkout.onCustomerChange);
            checkout.listenTo(cart,"changeContext", checkout.onChangeEdenred);
            checkout.listenTo(cart,"empty", checkout.onEmpty);
            checkout.on("change:step_rewrite", checkout.validateSteps);
            checkout.listenTo(cart,"change:products", checkout.onChangeProduct);
            checkout.listenTo(EdenredDataModel,'change', checkout.onChangeEdenred);
            checkout.listenTo(cart,'change:cagnotte', checkout.onChangeEdenred);
            checkout.validateSteps();
        },

        isV2:function(){
            return app.isCheckoutV2();
        },

        getSteps:function () {
            return steps;
        },

        getStepFromRewrite:function(step_rewrite){
            var step_id = default_step,
                step = steps.findWhere({rewrite:step_rewrite || this.get('step_rewrite')});
            if(step){
                step_id = step.id;
            }
            return step_id;
        },

        // vérifie si l'étape doit être ouverte
        isCurrentStep:function(targetStep){
            return targetStep === this.get('current_step');
        },
        getComeinIcon: function() {
            var icon = null
            hooks.execHook('CustomerComeInIcon', null, function(template) {icon = template})
            return icon
        },
        getOrderStep:function(){
            // static step start at 5 for checkout
            return 1 + (this.getCurrentStepIndex() || 0);
        },
        // retourne "in" si la classe est ouverte (pour une classe CSS)
        collapseIn:function(targetStep){
            return this.isCurrentStep(targetStep)?'in':''
        },

        isEmpty:function(){
          return this.get('empty');
        },

        isMobile:function(){
          return app.isMobile();
        },

        onChangeProduct:function(){
            this.validateSteps();
            this.onChangeEdenred();
        },

        validateSteps:function(){
            var checkout = this,
                customer = getCustomer(),
                isLogged = customer.isLogged(),
                stepFromRewrite = checkout.getStepFromRewrite(),
                cart = getCart(),
                cartChanged = cart.changed,
                unavailable_products = cartChanged.unavailable_products,
                isEmptyCart = cart.isEmpty(true),
                active_step = default_step,
                active_index = 0,
                beforeActive = true,
                hasMinimumPrice = cart.hasMinimumPrice(),
                require_product = isEmptyCart || !hasMinimumPrice,
                require_delivery_options = cart.get('store_closed'),
                invalidActive = false,
                dataSet = {
                    empty:isEmptyCart,
                    auth:isLogged
                };

            function loopValidation(){
                steps.each(function(step,i){
                    var prev = false,
                        active = step.active = stepFromRewrite === step.id,
                        invalid = (step.require_product ? require_product : false) || (step.require_valid_delivery_options ? require_delivery_options : false);
                    if(active){
                        beforeActive = false;
                        active_step = step.id;
                        active_index = i;
                        invalidActive = invalid;
                    }else if(beforeActive){
                        prev = true;
                    }
                    step.prev = prev;
                });
                dataSet.current_step = active_step;
                function goCart(){
                    app.go('cart');
                }
                if(invalidActive){
                    if(require_delivery_options){
                        cart.requireDeliveryOptions('all',true,function(){
                            goCart();
                        });
                    }else if(isEmptyCart && !unavailable_products){
                        cart.alertEmptyCart(goCart);
                    }else if(!hasMinimumPrice){
                        cart.alertMinimumPrice(goCart);
                    }
                    // first step is default active step
                    stepFromRewrite = steps.first().id;
                    return loopValidation();
                }
                checkout.set(dataSet);
            }

            return loopValidation();
        },

        nextStep:function(backStep){
            var model = this,
                currentStepIndex = model.getCurrentStepIndex(),
                nextStep = steps.find(function(s,i){
                    return i===currentStepIndex+(backStep?-1:1)
                });
            if(nextStep){
                app.go('checkoutOpc',nextStep);
            }else if(currentStepIndex===2){
                // final step
                model.submitCheckout();
            }
        },

        getQuantity:function(){
            return getCart().getQuantity();
        },

        onEmpty:function(){
            this.set('empty',true);
        },

        formatPrice:function(){
          return getCart().formatPrice()
        },

        getCagnotte:function(){
            return getCustomer().getCagnotteAmount();
        },
        useCagnotte:function(){
            return getCart().useCagnotte();
        },
        getCagnotteUsed:function(){
            return getCart().getCagnotte();
        },
        formatCagnotteUsed:function(){
            return getCart().formatCagnotteUsed();
        },

        allCartProductListOptions:function(){
            function ConstructCartProductListOptions(type,title,missing,cta){
                var cart = getCart(),
                    t = app.t,
                    noResultsMessage = app.t('Vous n’avez pas %s dans votre commande', _CART_TRANSLATION_CONTEXT_, t(missing, _CART_TRANSLATION_CONTEXT_)),
                    extraOptions,
                    baseOptions = {
                        type: type,
                        title: t(title, _CART_TRANSLATION_CONTEXT_),
                        noResultsMessage: noResultsMessage,
                        cta: t(cta, _CART_TRANSLATION_CONTEXT_),
                    };
                try {
                    var ctaUrl, category_default, id_category = '', products, unavailableProducts, isEmpty;
                    ctaUrl = UrlFactory.getUrl('allCategories');
                    products = cart.getProductsNonConsumable();
                    unavailableProducts = cart.getProductsIndispo();
                    isEmpty = (products.size() + unavailableProducts.size()) <= 0;
                    extraOptions = {
                        error:false,
                        ctaUrl: ctaUrl,
                        id_category: id_category,
                        isEmpty: isEmpty,
                        products: products,
                        unavailableProducts: unavailableProducts,
                        app: app
                    }
                }catch(err){
                    // si on a un problème sur un slug ou autre...
                    extraOptions = {
                        error:true,
                        errorMessage:t('Erreur','UI')+' : '+t(title,_CART_TRANSLATION_CONTEXT_)+ ' > '+type+' > '+category_default
                    }
                }
                return _(baseOptions).extend(extraOptions);
            }
            return ConstructCartProductListOptions('all','Produits','de produit','un produit');
        },

        validateCartDeliveryAddress:function(){
            var cart = getCart();
            if(!cart.getStore()){
                checkout.requireDeliveryOptions('all');
            }
            cart.validateDeliveryAddress();
        },

        getCurrentStep:function () {
            return steps.findWhere({id:this.get('current_step')});
        },
        getCurrentStepIndex:function () {
            return steps.findIndex({id:this.get('current_step')});
        },

        requireDeliveryOptions:function(type){
            setTimeout(function(){getCart().requireDeliveryOptions(type)});
        },

        getFullname:function(){
            var customer = getCustomer();
            return customer.isLogged() ? customer.getFullname() : '';
        },

        isLogged:function(){
            return getCustomer().isLogged();
        },

        requireAuthentification:function(confirmBefore){
            var customer = getCustomer(),
                require = !customer.isLogged();
            if(require){
                function displayModal() {
                    var authentificationPageView = new AuthentificationPageView({
                        register: true,
                        newsletter: false,
                        comeinId: false,
                        flagcomin: false,
                        isComein: false,
                    });
                    authentificationPageView.trackPageView();
                    app.displayModal(authentificationPageView);
                }
                if(confirmBefore){
                    app.confirm({title:app.t('Attention','UI'),subtitle:confirmBefore},function(confirm){
                        if(confirm){
                            displayModal();
                        }
                    })
                }else{
                    displayModal();
                }
            }else if(customer.requireRgpdOptin()){
                //
                require = true;
                app.displayModal(new OptinRgpdView());
            }
            return require;
        },

        formatPriceTotal:function(){
            return getCart().formatPriceTotal();
        },

        isZeroTTC:function(){
            return getCart().isZeroTTC();
        },

        totalPricePayments:function(){
            var model = this,
                details = [],
                altPM = model.getEdenredPaymentMode(),
                usedPM = model.getUsedPaymentMode(),
                edenredToPay = EdenredDataModel.getUsedAvailable(),
                totalLeftToPay = EdenredDataModel.getPrices('totalLeftToPay'),
                payedBy = 'Réglé par %s';
            if(EdenredDataModel.isActive() && altPM && EdenredDataModel.requireAltPM()){
                details.push({
                    label:app.t(payedBy,_CHECKOUT_TRANSLATION_CONTEXT_,altPM.get('name')),
                    price:formatPrice(edenredToPay)
                });
                details.push({
                    label:app.t(payedBy,_CHECKOUT_TRANSLATION_CONTEXT_,usedPM ? usedPM.get('name') : '...'),
                    price:formatPrice(totalLeftToPay)
                });
            }

            return _(details);
        },

        templateSubmit:function(){
            var model = this,
                currentStep = model.getCurrentStep(),
                price = model.formatPriceTotal(),
                unavailable = getCart().getProductsIndispo().size();
            return submitTemplate({
                unavailable:unavailable,
                price:price,
                label: app.t(currentStep.submitLabel, 'Checkout')
            });
        },

        getCart:function(){
            return getCart();
        },

        getPaymentMode:function(id_payment_mode){
            return getCart().getPaymentMode(id_payment_mode);
        },

        getCustomer:function(){
            return getCustomer();
        },

        getPaymentMethods:function(){
            return getCart().getPaymentMethods();
        },

        getPaymentGroups:function(location){
            var paymentGroups = getCart().getPaymentGroups();
            if(location>=0){
                paymentGroups = new PaymentGroupCollection(paymentGroups.filter({location:location}));
            }
            return paymentGroups;
        },

        usePaymentMode:function(paymentMode){
            getCart().usePaymentMode(paymentMode);
            var id_payment_mode = paymentMode ? paymentMode.id : null;
            this.set('id_payment_mode',id_payment_mode);
            if(!paymentMode){
                return
            }
            return paymentMode.getRequirement();
        },
        getUsedPaymentMode:function(){
            return getCart().getUsedPaymentMode();
        },
        getPresetPaymentMode:function(){
            var checkoutModel = this,
                presetPaymentMode = checkoutModel.getOgonePaymentMode();
            if(!EdenredDataModel.requireAltPM() && EdenredDataModel.isActive()){
                // noop
                presetPaymentMode = checkoutModel.getEdenredPaymentMode();
            }else if(presetPaymentMode) {
                var cards = presetPaymentMode.getCards(),
                    firstAvailableCard = cards.findWhere({disabled:false});
                if(firstAvailableCard){
                    presetPaymentMode.setOption('id_card',firstAvailableCard.id_card,true);
                }else{
                    presetPaymentMode = null;
                }
            }
            return presetPaymentMode;
        },
        getPaymentModeSelectionOptions:function(){
            // retourne les paramètres utiles au template de selection
            var checkoutModel = this,
                desc = {};
            var paymentMode = getCart().getUsedPaymentMode();
            if(!checkoutModel.isFetched()){
                desc = {
                    desc_primary:'<div class="circle-loader playing"></div>',
                    desc_secondary:'',
                    change_label:'',
                }
            }else if(paymentMode){
                if(checkoutModel.getPaymentGroups(0).getPaymentMode(paymentMode.id) || (paymentMode.isZero())){
                    desc = paymentMode.getDesc();
                }else if(EdenredDataModel.isActive()){
                    desc = {
                        desc_primary:app.t('Votre solde myEdenred est suffisant pour payer votre commande',_CHECKOUT_TRANSLATION_CONTEXT_),
                        desc_secondary:'',
                        change_label:'',
                        disabled:true,
                    }
                }
            }
            return _.defaults(desc,{
                tagName:'button',
                pict:false,
                disabled:false,
                class_list:'',
                warnings: [],
                desc_primary:app.t('Veuillez ajouter un mode de paiement',_CHECKOUT_TRANSLATION_CONTEXT_),
                dark:true,
                desc_secondary:false,
                change_label:app.t('Ajouter','UI')
            });
        },

        onCustomerChange:function(customer){
            //
            var model = this,
                phone = '';
            if(customer.isLogged()){
                phone = customer.getPhone();
                model.validateCartDeliveryAddress();
            }else{
                getCart().setCagnotte(0);
            }
            model.set('phone',phone);
            model.validateSteps();
        },

        onChangeEdenred:function(){
            var checkoutModel = this,
                requireAltPM = EdenredDataModel.requireAltPM(),
                edenredIsActive = EdenredDataModel.isActive(),
                displaySelectPM = requireAltPM || !edenredIsActive;
            var model = this;
            //
            var edenredPaymentMode = checkoutModel.getEdenredPaymentMode(),
                usedPaymentMode = checkoutModel.getUsedPaymentMode(),
                alt_payment_mode = null;
            if(!displaySelectPM){
                // si on est en paiement total myEdenred, il est selectionné
                checkoutModel.usePaymentMode(edenredPaymentMode);
            }else if(usedPaymentMode){
                if(edenredPaymentMode && usedPaymentMode.id === edenredPaymentMode.id){
                    // si on était en paiement edenred unique (VAE par exemple)
                    // et qu'on repasse en classique ou double paiement
                    // on utilise la valeur par défaut
                    checkoutModel.usePaymentMode(null);
                }else if(!usedPaymentMode.getParam('can_use_in_multi_payment')){
                    // si le mode de paiement ne supporte pas le multi paiement
                    // on essaie de rafraichir le bouton de paiement
                }
                if(edenredIsActive && requireAltPM && edenredPaymentMode){
                    alt_payment_mode = edenredPaymentMode.id;
                }
            }
            model.set('alt_payment_mode',alt_payment_mode);
            app.trigger('changePaymentModeParams');
            model.applyPreset();
        },

        isFetched:function(){
            return EdenredDataModel.isFetched();
        },

        applyPreset: function(){
            var checkoutModel = this,
                paymentMode = checkoutModel.getUsedPaymentMode(),
                isAvailable = !!paymentMode;
            if(isAvailable){
                // on vérifie que la sélection précédente est disponible dans le shop actuel
                var initial_id_payment_mode = paymentMode.id,
                    newPaymentMode;
                newPaymentMode = checkoutModel.getPaymentModeWhere(initial_id_payment_mode);
                if(!newPaymentMode){
                    isAvailable = false;
                }else if(newPaymentMode.cid !== paymentMode.cid){
                    newPaymentMode.set('options',paymentMode.getOptions());
                    paymentMode = newPaymentMode;
                }
            }
            if(checkoutModel.isZeroTTC()){
                // force le paiement à zero euro
                paymentMode = getZeroPaymentMode();
                isAvailable = !!paymentMode;
            }
            if(!isAvailable){ // par défaut, on selectionne Ogone
                paymentMode = checkoutModel.getPresetPaymentMode();
            }
            if(!paymentMode) paymentMode = null;
            checkoutModel.usePaymentMode(paymentMode);
        },

        isFixedRecipe:function(){
            return getCart().isFixedRecipe();
        },

        getOrderMessage:function(defaultMessage,ignoreDefault){
            if(!ignoreDefault && _.isUndefined(defaultMessage)) defaultMessage = app.t('Message au shop','Cart');
            var message = getCart().getOrderMessage();
            return message || defaultMessage || '';
        },

        getPhone:function(){
            var phone = this.get('phone');
            return phone || '';
        },

        getUseAsPhoneCustomer:function(){
            return !!this.get('useasphonecustomer');
        },

        getNIF:function(){
            var tax_identification_number = this.get('tax_identification_number');
            return tax_identification_number || '';
        },

        getEdenredDataModel:function(){
            return EdenredDataModel;
        },

        getOgonePaymentMode:function(){
            var OgoneProvider = this.getPaymentModeWhere({provider:'OgoneProvider'},0);
            var OgoneDirectProvider = this.getPaymentModeWhere({provider:'OgoneDirectProvider'},0);
            return OgoneProvider || OgoneDirectProvider;
        },

        getPaymentModeWhere:function(where,location){
            var checkout = this,
                pm = null,
                cart = getCart(),
                isVAE = cart.isVAE();
            if(_.isString(where)){
                where = {
                    id_payment_mode:where
                }
            }
            where[isVAE?'vae':'vad'] = true;
            checkout.getPaymentGroups(location).each(function(paymentGroup){
                if(!pm) pm = paymentGroup.getPaymentModes().findWhere(where);
            });
            return pm;
        },

        getEdenredPaymentMode:function(){
            return app.getPaymentModes().findWhere({provider:'EdenredProvider'});
        },

        useRestaurantVoucher:function(){
            // est-ce que Edenred existe, et bien dans le group voulu.
            var group = this.getRestaurantVoucherGroup();
            return group && !! group.getPaymentModes().size();
        },
        displayRestaurantVoucher:function(){
            return EdenredDataModel.displaySwitch() && this.useRestaurantVoucher();
        },
        getRestaurantVoucherGroup:function(){
            return app.getPaymentGroups().findWhere({location:1});
        },

        isVAD:function(){
            return getCart().isVAD();
        },
        isVAE:function(){
            return getCart().isVAE();
        },

        submitCheckout:function(){

            var model = this,
                cart = getCart(),
                store = cart.getStore();
            var phone = model.get('phone');
            phone = phoneUtils.validate(phone);

            function submitLoading(state){
                model.trigger('submitLoading',!!state);
            }

            if(model.requireAuthentification()){
                return false;
            }

            if(!store){
                model.requireDeliveryOptions();
                return false;
            }

            if(cart.isFreeProductSelectionRequired()){
                cart.reopenFreeProductChoice();
                return false;
            }

            if(cart.isVAD()){
                var temporaryAddress = cart.getTemporaryAddress(),
                    temporaryAddressData = temporaryAddress ? temporaryAddress.getData() : '',
                    addressData = model.get('addressData');

                if(!temporaryAddress){
                    // si on a pas d'adresse temporaire, on ouvre le selecteur d'adresse
                    model.requireDeliveryOptions();
                    return false;
                }
                if(addressData === null){
                    addressData = temporaryAddressData || '';
                }
                if(addressData !== temporaryAddressData){
                    temporaryAddress.set('data',addressData);
                }

                if(app.checkoutAddressDataCheck() && !cart.hasCheckDeliveryAddressData(temporaryAddress)) {
                    var subtitle = app.t('Aucune instructions de livraison n’ont été saisies : ', _CHECKOUT_TRANSLATION_CONTEXT_) + "<br/>" +
                    app.t("Interphone, Code, Étage etc. ", _CHECKOUT_TRANSLATION_CONTEXT_);
                    app.confirm(app.t({
                        title: app.t('Attention', 'UI'),
                        subtitle: subtitle,
                        validation: app.t('Saisir','UI'),
                        cancel: app.t('Ignorer','UI'),
                    }),function(confirm){
                        if(confirm){
                            model.trigger('focusAddressData');
                            cart.set('deliveryAddressDataCheckSum',false);
                        }else{
                            model.submitCheckout();
                        }
                    })
                    return false;
                }else if(temporaryAddress.isNew() || (!!temporaryAddress.changed && _.isString(temporaryAddress.changed.data))){
                    // si l'adresse est nouvelle ou que l'on a changer les data, on enregistre l'adresse
                    submitLoading(true);
                    temporaryAddress.save({data:addressData}).done(function(addressData){
                        cart.set('id_address_delivery',temporaryAddress.id);
                        model.submitCheckout();
                    }).fail(function(){
                        app.alert();
                        submitLoading(false);
                    });
                    return false;
                }
            }

            if (!phone) {
                submitLoading(false);
                app.banNotice(app.t('Merci de rentrer un téléphone valide', _CHECKOUT_TRANSLATION_CONTEXT_));
                return false;
            }

            var options = {
                total_price_ttc:getCart().getPriceTTC(),
                phone: phone,
                amountReduce: model.getCagnotteUsed(), // cagnotte
                informations: model.getOrderMessage(false,true),
                useasphonecustomer: model.getUseAsPhoneCustomer() ? 1 : 0, // warning : force override every time
            };

            // utilisation de l'identifiant de taxe (Portugal)
            if ( app.c('_CUSTOMER_ENABLE_TAX_IDENTIFICATION_NUMBER_') == 1 ) {
                var tax_identification_number = model.getNIF();
                if(!validatorNIF(tax_identification_number)){
                    submitLoading(false);
                    app.banNotice(app.t('Merci de rentrer un numéro d\'identification valide', _CHECKOUT_TRANSLATION_CONTEXT_));
                    return false;
                }
                options.tax_identification_number = tax_identification_number;
            }

            if(!model.isFetched()){
                app.alert('Veuillez patienter','UI');
                return false;
            }

            var paymentMode = model.getUsedPaymentMode(),
                requirement = paymentMode ? paymentMode.getRequirement() : -1,
                Warning = app.t('Attention','UI');
            switch(requirement){
                case PROVIDER_REQUIRE_OGONE_DIRECT_FORM:
                    if(!paymentMode.getOption('initModal')){
                        app.trigger('paymentModeRequirement', paymentMode, requirement);
                        return false;
                    }
                    break;
                case PROVIDER_REQUIRE_SIMPLE_PAYMENT:
                    var title = 'Vous ne pouvez pas utiliser le mode de paiement « %1$s » en complément de « %2$s. »',
                        pmName = paymentMode.get('name'),
                        edenredName = model.getEdenredPaymentMode().get('name');
                    app.confirm({
                        title:Warning,
                        subtitle:app.t(title,_CHECKOUT_TRANSLATION_CONTEXT_,[pmName,edenredName]),
                        validation:app.t('Changer',_CHECKOUT_TRANSLATION_CONTEXT_),
                        cancel:app.t('Retirer %s',_CHECKOUT_TRANSLATION_CONTEXT_,edenredName)
                    },function(confirm){
                        if(confirm){
                            app.trigger('requirePaymentModeSelection');
                        }else{
                            app.trigger('requireDisableEdenred');
                        }
                    });
                    return false;
                case PROVIDER_REQUIRE_OGONE_VALID_BRAND:
                    app.alert(paymentMode.getParam('require_valid_brand_message'));
                    return false;
                case PROVIDER_REQUIRE_OGONE_CVC:
                    app.trigger('CVCError');
                    return false;
                case -1:
                    // cas où l'utilisateur clique sur commander, et qu'il n'a pas de mode de paiement,
                    // il sera alors dans un cas
                    app.trigger('paymentModeRequirement', null, requirement);
                    return false;
                case 0:
                    // OK !!
                    break;
                default:
                    app.alert();
                    return false;
            }

            submitLoading(true);

            function doPaymentFinal(){
                // en cas d'erreur ou de succes, le bouton est réinitialisé
                cart.off('doPaymentError',doPaymentFinal);
                submitLoading(false);
            }

            cart.once('doPaymentError',doPaymentFinal);
            cart.doPayment(options, doPaymentFinal);
            return true;
        },

        contactlessDeliveryVisible:function(){
            var product = app.getProduct(app.c('_CONTACTLESS_DELIVERY_PRODUCT_'));
            return app.c('_CONTACTLESS_DELIVERY_ENABLED_','1') === '1' && !!product && product.isBuyableInContext();
        },

        contactlessDeliveryChecked:function(){
            return !!getCart().getProduct(app.c('_CONTACTLESS_DELIVERY_PRODUCT_'))
        },

        displayNoDeliveryOptions:function(){
            return app.t('Merci de renseigner votre adresse de livraison ou votre shop de retrait', _CHECKOUT_TRANSLATION_CONTEXT_)
        },

    });

    CheckoutModel.getStep = GetStep;

    return CheckoutModel;

});
